import React from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    TimeScale,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { converteParaHorarioLocal } from "../utils/utils";
import { Line } from "react-chartjs-2";
import "chartjs-adapter-moment";
import moment from "moment";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    TimeScale,
    Title,
    Tooltip,
    Legend
);

export default function GraficoCorrentesRele({ dataRele, date }) {
    const options = {
        radius: 1, // desabilitar pontos,
        locale: 'pt-br',
        scales: {
            x: {
                grid: {
                    display: false,
                },
                type: "time",
                time: {
                    unit: "hour",
                    displayFormats: {
                        hour: "HH:00",
                    },
                },
                min: moment(new Date(date.year, date.month - 1, date.day, 5, 0, 0)),
                max: moment(new Date(date.year, date.month - 1, date.day, 20, 0, 0)),
            },
            A: {
                type: "linear",
                position: "left",
                title: {
                    display: true,
                    text: "Corrente (Amperes)",
                },
            },
        },
        responsive: true,
        plugins: {
            legend: {
                position: "top",
            },
            // title: {
            //     display: true,
            //     text: "Correntes de fase",
            // },
        },
        tension: 0.4,
    };

    const data = {
        labels: dataRele?.map((i) => converteParaHorarioLocal(i.data)),
        datasets: [
            {
                label: "Corrente de fase A",
                data: dataRele?.map((i) => i.corrente_a),
                borderColor: "rgb(255, 99, 132)",
                backgroundColor: "rgba(255, 99, 132, 0.5)",
            },
            {
                label: "Corrente de fase B",
                data: dataRele?.map((i) => i.corrente_b),
                borderColor: "rgb(53, 162, 235)",
                backgroundColor: "rgba(53, 162, 235, 0.5)",
            },
            {
                label: "Corrente de fase C",
                data: dataRele?.map((i) => i.corrente_c),
                borderColor: "rgb(0, 128, 8)",
                backgroundColor: "rgba(0, 128, 0, 0.5)",
            },
        ],
    };

    return <Line options={options} data={data} />;
}
